<template>
  <div class="component-interaction">
    <main ref="scrollY">
      <transition-group name="transition" tag="ul">
        <div class="interaction" v-for="(interaction,index) in componentInteraction" :key="interaction.id">
          <div class="title">控件交互{{componentInteraction.length - index}}<i class="el-icon-close del-interaction" @click="delInteraction(index)"></i></div>
          <div class="content">
            <el-form ref="form" class="form" label-position="left" :model="interaction">
              <!--拆分为3个组件,隔离响应式数据造成的重复渲染-->
              <!--c1: 控件选择-->
              <component-interaction-trigger-components
                :interaction="interaction"
                :options="options"
                :isProcess="isProcess">
              </component-interaction-trigger-components>

              <!-- c2: 满足条件的设置-->
              <component-interaction-conforms
                :conforms="interaction.conforms"
                :conformsControls="conformsControls"
                :triggerComponents="interaction.triggerComponents"
                :isProcess="isProcess"
                :options="options"
                @openCalculate="openCalculate"></component-interaction-conforms>

              <!--c3: 不满足条件的设置-->
              <component-interaction-no-conforms
                :noConforms="interaction.noConforms"
                :noConformsControls="noConformsControls"
                :triggerComponents="interaction.triggerComponents"
                :isProcess="isProcess"
                :options="options"
                @openCalculate="openCalculate"></component-interaction-no-conforms>
            </el-form>
          </div>
        </div>
      </transition-group>
    </main>
    <i class="el-icon-plus add-interaction" @click="addInteraction"> 添加控件交互</i>
  </div>
</template>

<script>
import { ProcessComponent, TableComponent } from '@/store/form/component'
import { calculateMixin } from '@/components/form/components/mixins'
import CalculationPanel from '@/components/shared/calculation-panel.vue'
import { dataSourceReport } from './designMixins/mixins'
import publicCombobox from '@/components/public/public-combobox.vue'
import componentInteractionTriggerComponents from './componentInteractionAttrChildren/component-interaction-trigger-components.vue'
import componentInteractionConforms from './componentInteractionAttrChildren/component-interaction-conforms.vue'
import componentInteractionNoConforms from './componentInteractionAttrChildren/component-interaction-no-conforms.vue'
import { UUID } from '@/plugins/common'

export default {
  name: 'ComponentInteractionAttr',
  mixins: [ calculateMixin, dataSourceReport ],
  props: [ 'componentInteraction' ],
  inject: [ 'formService' ],
  components: {
    CalculationPanel,
    publicCombobox,
    componentInteractionTriggerComponents,
    componentInteractionConforms,
    componentInteractionNoConforms
  },
  data () {
    return {
      conformsControls: [],
      noConformsControls: []
    }
  },
  mounted () {
    this.conformsControls = this.$_.merge([], this.options)
    this.noConformsControls = this.$_.merge([], this.options)
  },
  methods: {
    addInteraction () {
      this.componentInteraction.unshift({
        id: UUID.create(),
        triggerComponents: [],
        // 满足条件
        conforms: [],
        // 不满足条件
        noConforms: [],
        // 条件关系
        relation: true
      })
      // 400是弹窗限制的最大高度
      this.$nextTick(() => {
        let scrollY = this.$refs.scrollY
        scrollY.scrollTop = 0
      })
    },
    delInteraction (index) {
      this.componentInteraction.splice(index, 1)
    },
    openCalculate (expression, item) {
      // 如果 changeComponent 选的是全部都是表格内的控件，则不必须使用聚合函数
      let tables = 0
      if (item.changeComponent && item.changeComponent.length > 0) {
        for (let i = 0; i < item.changeComponent.length; i++) {
          let tableId = this.conformsControls.find(c => c.id === item.changeComponent[0]).tableId
          if (tableId) {
            let option = this.options.find(c => c.id === tableId)
            if (option) {
              if (option.componentType === 'rc-table') {
                tables++
              }
            }
          }
        }
      }
      this.$Popup.calculation({
        parameter: {
          expression: expression,
          dataSource: this.getDataSource,
          needConcat: tables !== item.changeComponent.length
        },
        width: '1000px',
        calculationType: 'java'
      }).then((data) => {
        // action 两种 confirm 表示点击的是确认, cancel 表示取消
        if (data.action === 'confirm') {
          item.calculate = data.value
        }
      })
    },
    validate () {
      const validArr = []
      this.$refs.form && this.$refs.form.forEach((item) => {
        const result = new Promise((resolve, reject) => {
          item.validate((valid) => {
            if (valid) {
              resolve()
            } else {
              reject(new Error('error'))
            }
          })
        })
        validArr.push(result)
      })
      return validArr
    }
  },
  computed: {
    isProcess () {
      return this.formService.getComponents().some(n => n instanceof ProcessComponent)
    },
    formComponent () {
      let result = this.$_.cloneDeep(this.formService.getComponents().filter(n => n.componentType === 'rc-form'))
      result.forEach(n => {
        let childrens = this.$_.cloneDeep(n.children)
        n.children = n.archivedChildren
        childrens.forEach(el => {
          if (el.componentType === 'rc-group') {
            el.children = []
            n.children.push(el)
          }
        })
      })
      return result
    },
    options () {
      let options = []
      if (this.formComponent.length) {
        this.formComponent.forEach(form => {
          form.children.forEach(component => {
            if (component instanceof TableComponent && component.componentType === 'rc-table') {
              options.push({
                componentType: component.componentType,
                id: component.id,
                name: component.name,
                tableId: '',
                tableName: '',
                formId: form.id,
                formName: form.name,
                pinyinName: component.pinyinName,
                pinyinFirstChar: component.pinyinFirstChar,
                pnl: this.isProcess ? `${form.pinyinName}-${component.pinyinName}` : '',
                pfcl: this.isProcess ? `${form.pinyinFirstChar}-${component.pinyinFirstChar}` : ''
              })
              component.children.forEach(tableChild => {
                options.push({
                  componentType: tableChild.componentType,
                  id: tableChild.id,
                  name: tableChild.name,
                  tableId: component.id,
                  tableName: component.name,
                  formId: form.id,
                  formName: form.name,
                  pinyinName: `${component.pinyinName}-${tableChild.pinyinName}`,
                  pinyinFirstChar: `${component.pinyinFirstChar}-${tableChild.pinyinFirstChar}`,
                  pnl: this.isProcess ? `${form.pinyinName}-${component.pinyinName}-${tableChild.pinyinName}` : '',
                  pfcl: this.isProcess ? `${form.pinyinFirstChar}-${component.pinyinFirstChar}-${tableChild.pinyinFirstChar}` : ''
                })
              })
            } else {
              options.push({
                componentType: component.componentType,
                id: component.id,
                name: component.name,
                tableId: '',
                tableName: '',
                formId: form.id,
                formName: form.name,
                pinyinName: component.pinyinName,
                pinyinFirstChar: component.pinyinFirstChar,
                pnl: this.isProcess ? `${form.pinyinName}-${component.pinyinName}` : '',
                pfcl: this.isProcess ? `${form.pinyinFirstChar}-${component.pinyinFirstChar}` : ''
              })
            }
          })
        })
      }
      let filterType = ['rc-input', 'rc-textarea', 'rc-numeric', 'rc-combobox', 'rc-date', 'rc-data-source', 'rc-upload', 'rc-file', 'rc-table', 'rc-group', 'rc-currency', 'rc-rich-box', 'rc-radio', 'rc-checkbox', 'rc-uuid', 'rc-phone', 'rc-login-user', 'rc-password', 'rc-flowing-water', 'rc-coding', 'rc-children-input', 'rc-member']
      return options.filter(option => filterType.some(n => n === option.componentType))
    }
  },
  watch: {}
}
</script>

<style lang="scss">
   .component-interaction {
    main {
      max-height: 400px;
      overflow-y: auto;

      .interaction {
        margin-bottom: 10px;
        border: solid 1px #DBDBDB;
        border-radius: 4px;
        overflow: hidden;

        .title {
          height: 31px;
          line-height: 31px;
          background-color: #EBF5FF;
          padding-left: 10px;
          color: #232323;

          .del-interaction {
            display: none;
            float: right;
            color: #606266;
            line-height: 28px;
            margin-right: 10px;
            font-size: 14px;
            cursor: pointer;
          }

          &:hover .del-interaction {
            display: inline;
          }
        }

        .content {
          padding: 10px;
          .close-list {
              display: none;
              width: 12px;
              height:12px;
              font-size: 10px;
              border-radius: 50%;
              background: transparent;
              text-align: center;
              line-height: 8px;
              cursor: pointer;
              color: #C2C3C4;
              position: absolute;
              right: 0;
              top: 43%;
              margin-top: -6px;
              &:hover {
                background: #FB9391;
                color: #fff;
              }
              &:active {
                background: #EE5451;
                color: #fff;
              }
            }

          .list {
            overflow: hidden;
            position: relative;
            padding-right: 10px;
            margin-bottom: 10px;

            &:hover .close-list {
              display: inline;
            }

            .fx {
              position: absolute;
              top: 50%;
              left: 212px;
              margin-top: -9px;
              width: 18px;
              height: 18px;
              font-family: MicrosoftYaHei;
              font-size: 12px;
              background: #EDEEEE;
              border: solid 1px #C2C3C4;
              border-radius: 4px;
              text-align: center;
              cursor: pointer;
            }

            .el-form-item {
              float: left;
              width: 212px;
              margin: 0;

              &:first-child {
                margin-right: 20px;
              }

              label {
                min-width: auto;
              }

              .el-form-item__content {
                width: 100%;
                padding: 0 2px;
              }
            }

            .el-select,
            .el-input {
              width: 208px;
            }

            .close-list {
              top: 50%;
            }
          }

          .el-form-item {
            position: relative;
            margin-bottom: 10px;
            &.component-condition {
              display: inline-block;
            }

            label {
              min-width: 82px;
              font-size: 12px;
            }

            .el-icon-plus {
              display: block;
              position: absolute;
              right: 0;
              top: 50%;
              margin-top: -7px;
              color: #54ABF1;
              cursor: pointer;
              font-size: 10px;
              &:active{
                color: #2480CA;
              }
            }
          }

        }
      }
    }

    .add-interaction {
      display: block;
      width: 103px;
      color: #54ABF1;
      cursor: pointer;
      margin: 0 auto;
      margin-top: 10px;
      &:active {
       color: #2480CA;
      }
    }

    .el-select {
      width: 100%;

      .el-select__tags {
        >span>span:nth-child(1) {
          .el-select__tags-text {
            width: 60px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
          }

          .el-icon-close {
            top: -5px;
          }
        }

        >input {
          margin-left: 12px;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/component-interaction-attr.vue